import axios, { AxiosRequestConfig } from "axios";

export const config: AxiosRequestConfig = {
  baseURL: process.env.NEXT_PUBLIC_API_URL,
};

const axiosClient = axios.create(config);

export default axiosClient;
